import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME} from "../../Configs/Domain";
// Function to fetch tickers from the server
const fetchTickersFromServer = async (endpoint) => {
// Inside fetchTickersFromServer function
  const abortController = new AbortController();
  const signal = abortController.signal;

  const response = await fetch(`${HOSTNAME}${endpoint}`, { signal });
  console.log(response)
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();

};


export const loadTickerSearchList = createAsyncThunk(
  'tickerSearchList/load',
  async (_, { getState }) => {

    const { tickerSearchList } = getState();
    if (tickerSearchList.list.length > 0 && !tickerSearchList.forceReload) {
      return tickerSearchList.list;
    }
    try {
      const response = await fetchTickersFromServer('/tickers/catalog');
      return response.map(item => ({
        ...item,
        name: item.name.toLowerCase(),
      }));
    } catch (error) {
      throw error;
    }
  }
);

const tickerSearchListSlice = createSlice({
  name: 'tickerSearchList',
  initialState: {
    list: [],
    status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
    error: null,
    forceReload: false,
  },
  reducers: {
    setForceReload(state, action) {
      state.forceReload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadTickerSearchList.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(loadTickerSearchList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(loadTickerSearchList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});



export default tickerSearchListSlice;

export const { setForceReload } = tickerSearchListSlice.actions;

export const getTickersBySymbols = createSelector(
  [(state) => state.tickerSearchList.list, (state, symbols) => symbols],

  (list, symbols) => {
    const symbolSet = new Set(symbols); // Efficient lookup
    const filteredTickers = list.filter(ticker => symbolSet.has(ticker.symbol));
    return filteredTickers;
  }
);
